module.exports = __webpack_public_path__ + "img/iq.839b6309.jpg";